import * as types from '../../mutation-types'
import RacesService from '../../../services/races'
import StartRaceService from '../../../services/startRace'
import FinishRaceService from '../../../services/finishRace'
import TrainerNoteService from '../../../services/trainerNote'
import RunnersByRaceService from '../../../services/runnersByRace'
import AutoRunService from '../../../services/autoRun'

const actions = {
  get ({ commit, state }, id) {
    return RacesService.get(id).then((response) => {
      commit(types.GET_RACE, {
        race: response.data
      })
    })
  },

  getTypes ({ commit, state }) {
     return RacesService.getTypes()
  },
  start ({ commit, state }, id) {
    return StartRaceService.start(id)
  },
  finish ({ commit, state }, id) {
    return FinishRaceService.finish(id)
  },
  getRunners ({ commit, state }, id) {
    return RunnersByRaceService.getAll(id).then((response) => {
      commit(types.GET_RUNNERS_BY_RACE, {
        runners: response.data
      })
    })
  },
  createOne ({ commit, state }, race) {
    return RacesService.createOne(race)
  },
  deleteOne ({ commit, state }, race) {
    return RacesService.deleteOne(race)
  },
  updateOne ({ commit, state }, race) {
    if (!race) {
      console.error('No race data provided to updateOne')
      return Promise.resolve()
    }
    
    return RacesService.updateOne(race)
      .then(response => {
        // Return the response to maintain the Promise chain
        return response
      })
      .catch(error => {
        console.error('Error updating race:', error)
        return Promise.reject(error)
      })
  },
  updateStatusLive ({ commit, state }, id) {
    return RacesService.updateStatusLive(id)
  },
  updateNote ({ commit, state }, data) {
    return TrainerNoteService.updateNote(data)
  },
  startLive ({ commit, state },) {
    return commit("setIsRaceLive", true)
  },
  stopLive({ commit, state },) {
    return commit("setIsRaceLive", false)
  },
  startAutoRun({ commit, state }, raceId) {
    return AutoRunService.startAutoRun(raceId)
      .then(response => {
        console.log('Auto run started successfully', response.data)
        return response
      })
      .catch(error => {
        console.error('Error starting auto run:', error)
        return Promise.reject(error)
      })
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/races/actions.js